import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicSocialImage } from './AiImageDisclosure';

const ORIGIN = (process.env.REACT_APP_PUBLIC_URL || 'https://core-labs.de').replace(/\/$/, '');
const DEFAULT_IMAGE = `${ORIGIN}/og.png`;
export const INDEX_ROBOTS = 'index,follow,max-image-preview:large';
export const NOINDEX_ROBOTS = 'noindex,follow';

const ROUTES = {
    '/': ['Core Labs – Premium Websites, SEO & Software aus Schleswig-Holstein', 'Core Labs entwickelt individuelle Websites, verbessert die Sichtbarkeit bei Google und realisiert Software sowie Multiplayer-Mods – persönlich aus Schleswig-Holstein.'],
    '/leistungen': ['Leistungen & Preise | Core Labs', 'Webdesign, SEO, Wartung und individuelle Software mit klar beschriebenem Umfang, transparenten Preisen und persönlicher Betreuung.'],
    '/software': ['Produkte, Software & Multiplayer-Mods | Core Labs', 'Websites, SEO-Pakete, Automatisierung, Gameserver-Werkzeuge und Multiplayer-Mods mit klar definiertem Leistungsumfang.'],
    '/referenzen': ['Referenzen & Projekte | Core Labs', 'Ausgewählte Website-, SEO- und Softwareprojekte von Core Labs aus Neustadt in Holstein.'],
    '/ueber-uns': ['Über Core Labs | Digitalstudio aus Schleswig-Holstein', 'Lernen Sie Core Labs aus Neustadt in Holstein kennen: persönliche Webentwicklung, SEO und Software ohne anonyme Agenturwege.'],
    '/kontakt': ['Webprojekt anfragen | Core Labs', 'Besprechen Sie Ihre Website, SEO-Optimierung oder individuelle Software direkt mit Core Labs aus Neustadt in Holstein.'],
    '/faq': ['Häufige Fragen zu Websites, SEO & Software | Core Labs', 'Antworten zu Leistungen, Preisen, Projektablauf, CMS, SEO, Datenschutz und Support bei Core Labs.'],
    '/website-check': ['Kostenloser Website-Check | Core Labs', 'Website kostenlos auf SEO, Performance, Datenschutzsignale, Sicherheit und Barrierefreiheit prüfen und einen PDF-Bericht erhalten.'],
    '/tools': ['Kostenlose Website-Tools | Core Labs', 'Kostenlose Tools für SEO, Performance, Datenschutz, Barrierefreiheit, Sicherheit und Website-Planung – ohne Konto nutzbar.'],
    '/status': ['Systemstatus & Uptime | Core Labs', 'Aktueller Systemstatus und beobachtete Verfügbarkeit von Relay Server, Webserver, VPS Host und GameServer Host bei Core Labs.'],
    '/gameserver-leihen': ['Gameserver 24 Stunden kostenlos testen | Core Labs', 'Minecraft- und Steam-Gameserver 24 Stunden kostenlos testen und Ressourcen, unterstützte Einstellungen sowie Spielupdates sicher im Core Labs Kundenportal verwalten.'],
    '/tools/website-kostenrechner': ['Website-Kostenrechner | Core Labs', 'Website-Kosten kostenlos kalkulieren: Umfang und Funktionen auswählen und eine realistische Preisspanne für Ihr Projekt erhalten.'],
    '/tools/relaunch-kostenrechner': ['Relaunch-Kostenrechner | Core Labs', 'Kosten für einen Website-Relaunch kostenlos einschätzen – passend zu Umfang, Migration, Design, CMS und technischen Anforderungen.'],
    '/tools/local-seo-check': ['Kostenloser Local-SEO-Check | Core Labs', 'Lokale Auffindbarkeit Ihrer Unternehmenswebsite prüfen und konkrete Hinweise zu Standortsignalen, Inhalten und Google-Sichtbarkeit erhalten.'],
    '/tools/bfsg-check': ['Barrierefreiheits-Check nach BFSG | Core Labs', 'Website kostenlos auf technisch erkennbare Barrieren prüfen und verständliche Hinweise zu Kontrasten, Formularen und Bedienbarkeit erhalten.'],
    '/tools/cookie-tracker-check': ['Cookie- & Tracker-Check | Core Labs', 'Prüfen, welche Cookies und externen Dienste eine Website technisch erkennbar lädt und wo Datenschutzrisiken untersucht werden sollten.'],
    '/tools/snippet-schema-check': ['Google-Snippet- & Schema-Check | Core Labs', 'Seitentitel, Meta-Beschreibung und strukturierte Daten prüfen und eine Vorschau möglicher Google-Suchergebnisse ansehen.'],
    '/tools/performance-check': ['Website-Performance-Check | Core Labs', 'Ladezeit, Seitengröße, Bilder und technische Ressourcen kostenlos prüfen und konkrete Optimierungspotenziale erkennen.'],
    '/tools/redirect-check': ['Redirect- & Relaunch-Check | Core Labs', 'Weiterleitungen, Ketten und fehlerhafte Zielseiten prüfen – hilfreich vor und nach einem Website-Relaunch.'],
    '/tools/indexierungs-check': ['Google-Indexierungs-Check | Core Labs', 'robots.txt, Canonical, Noindex, Sitemap und weitere technisch erkennbare Indexierungssignale einer Website kostenlos prüfen.'],
    '/tools/system-check': ['Website-Systemcheck | Core Labs', 'Technisch erkennbare CMS-, Shop- und Serverhinweise prüfen und Empfehlungen zu Wartung, Updates und Sicherheit erhalten.'],
    '/tools/domain-email-ssl-check': ['Domain-, E-Mail- & SSL-Check | Core Labs', 'SSL, DNS sowie technisch erkennbare SPF-, DKIM- und DMARC-Einstellungen einer Domain kostenlos überprüfen.'],
    '/tools/social-preview-check': ['Social-Media-Vorschau prüfen | Core Labs', 'Open-Graph- und Social-Media-Metadaten prüfen und sehen, wie eine Website beim Teilen dargestellt werden kann.'],
    '/tools/kontrastpruefer': ['Kontrastprüfer für Websites | Core Labs', 'Farbkontraste kostenlos prüfen und erkennen, ob Texte nach gängigen Barrierefreiheitskriterien ausreichend lesbar sind.'],
    '/tools/text-cta-check': ['Website-Text- & CTA-Check | Core Labs', 'Überschriften, Handlungsaufforderungen und Seitenstruktur prüfen und verständliche Hinweise zur Nutzerführung erhalten.'],
    '/tools/sitemap-robots-generator': ['Sitemap- & robots.txt-Generator | Core Labs', 'Einfache sitemap.xml und robots.txt für eine Website erstellen und vor dem Einsatz technisch prüfen.'],
    '/tools/google-bewertungs-kit': ['Google-Bewertungslink & QR-Kit | Core Labs', 'Bewertungslink und QR-Code für Ihr Google-Unternehmensprofil erstellen – für Rechnung, Tischaufsteller oder Gästeinformation.'],
    '/tools/uptime-monitor': ['Kostenloser Website-Uptime-Monitor | Core Labs', 'Website-Erreichbarkeit kostenlos überwachen und bei technisch erkannten Ausfällen informiert werden.'],
    '/forum': ['Core Labs Forum | Websites, SEO & Software', 'Community und Support rund um Websites, SEO, Software und Multiplayer-Projekte.'],
    '/impressum': ['Impressum | Core Labs', 'Anbieterkennzeichnung und Kontaktdaten von Core Labs in Neustadt in Holstein.'],
    '/datenschutz': ['Datenschutzerklärung | Core Labs', 'Informationen zur Verarbeitung personenbezogener Daten bei Core Labs.'],
    '/agb': ['Allgemeine Geschäftsbedingungen | Core Labs', 'Allgemeine Geschäftsbedingungen für Leistungen und Produkte von Core Labs.'],
    '/widerruf': ['Widerrufsbelehrung | Core Labs', 'Informationen zum Widerrufsrecht und Muster-Widerrufsformular für Verbraucher.'],
    '/barrierefreiheit': ['Informationen zur Barrierefreiheit | Core Labs', 'Informationen zur barrierefreien Nutzung der digitalen Angebote von Core Labs sowie Kontakt- und Feedbackmöglichkeiten.'],
    '/kuendigung': ['Vertrag online kündigen | Core Labs', 'Elektronische Kündigungsfunktion für laufende Verbraucherverträge mit Eingangsbestätigung.'],
};

const KNOWN_PUBLIC_PATHS = new Set(Object.keys(ROUTES));
const DYNAMIC_CONTENT_PATH = /^\/(leistungen|software|referenzen)\/[^/]+$/;
const FORUM_PATH = /^\/forum\/(me|u\/[^/]+|t\/[^/]+|[^/]+)$/;
const PRIVATE_PATH = /^(\/admin|\/portal|\/login|\/register|\/verify-email|\/reset-password)(\/|$)|^\/forum\/(me|u\/)/;
const RESULT_QUERY_KEYS = new Set(['audit', 'id', 'report', 'result', 'scan', 'status', 'token']);

function upsertMeta(selector, attribute, value, content) {
    let element = document.head.querySelector(selector);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, value);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
}

function setCanonical(url) {
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
    }
    canonical.href = url;
}

function routeMeta(path) {
    if (ROUTES[path]) return ROUTES[path];
    if (path.startsWith('/leistungen/')) return ROUTES['/leistungen'];
    if (path.startsWith('/software/')) return ROUTES['/software'];
    if (path.startsWith('/referenzen/')) return ROUTES['/referenzen'];
    if (path.startsWith('/forum/')) return ROUTES['/forum'];
    return ROUTES['/'];
}

function readableSegment(segment) {
    const acronyms = new Set(['api', 'bfsg', 'cms', 'seo', 'ssl', 'cta']);
    return decodeURIComponent(segment).split('-').map(word => acronyms.has(word.toLowerCase())
        ? word.toUpperCase()
        : `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(' ');
}

function breadcrumbName(path, segment) {
    const title = ROUTES[path]?.[0]?.split('|')[0]?.trim();
    return title || readableSegment(segment);
}

export function buildBreadcrumbSchema(path) {
    if (path === '/') return null;
    const rawSegments = path.split('/').filter(Boolean);
    const segments = rawSegments[0] === 'forum' && ['t', 'u'].includes(rawSegments[1])
        ? [rawSegments[0], ...rawSegments.slice(2)]
        : rawSegments;
    if (!segments.length) return null;
    const itemListElement = [{
        '@type': 'ListItem', position: 1, name: 'Startseite', item: `${ORIGIN}/`,
    }];
    let current = '';
    segments.forEach((segment, index) => {
        current += `/${segment}`;
        itemListElement.push({
            '@type': 'ListItem',
            position: index + 2,
            name: breadcrumbName(current, segment),
            ...(index < segments.length - 1 ? { item: `${ORIGIN}${current}` } : {}),
        });
    });
    return { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement };
}

function syncRouteSchema(path, indexable) {
    document.head.querySelector('script[data-core-route-schema]')?.remove();
    if (!indexable) return;
    const data = path === '/' ? {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${ORIGIN}/#website`,
        url: `${ORIGIN}/`,
        name: 'Core Labs',
        alternateName: 'Core-Labs.de',
        inLanguage: 'de-DE',
        publisher: { '@id': `${ORIGIN}/#business` },
    } : buildBreadcrumbSchema(path);
    if (!data) return;
    const schema = document.createElement('script');
    schema.type = 'application/ld+json';
    schema.dataset.coreRouteSchema = 'true';
    schema.text = JSON.stringify(data);
    document.head.appendChild(schema);
}

function hasResultState(path, search) {
    if (!(path === '/website-check' || path.startsWith('/tools')) || !search) return false;
    return [...new URLSearchParams(search).keys()].some(key => RESULT_QUERY_KEYS.has(key.toLowerCase()));
}

export function getRouteSeoState(pathname, search = '') {
    const path = pathname !== '/' ? pathname.replace(/\/$/, '') : '/';
    const privatePage = PRIVATE_PATH.test(path) || path === '/kuendigung';
    const knownPage = KNOWN_PUBLIC_PATHS.has(path) || DYNAMIC_CONTENT_PATH.test(path) || FORUM_PATH.test(path);
    const dynamicPending = DYNAMIC_CONTENT_PATH.test(path);
    const indexable = !privatePage && knownPage && !dynamicPending && !hasResultState(path, search);
    return { path, indexable, knownPage, privatePage };
}

export function setPageSeo({ title, description, image = DEFAULT_IMAGE, type = 'website', robots }) {
    const socialImage = getPublicSocialImage(image);
    const resolvedTitle = title || document.title;
    const resolvedDescription = description || 'Core Labs';
    if (title) document.title = title;
    if (description) upsertMeta('meta[name="description"]', 'name', 'description', description);
    if (robots) upsertMeta('meta[name="robots"]', 'name', 'robots', robots);
    upsertMeta('meta[property="og:title"]', 'property', 'og:title', resolvedTitle);
    upsertMeta('meta[property="og:description"]', 'property', 'og:description', resolvedDescription);
    upsertMeta('meta[property="og:type"]', 'property', 'og:type', type);
    upsertMeta('meta[property="og:image"]', 'property', 'og:image', socialImage);
    upsertMeta('meta[property="og:image:alt"]', 'property', 'og:image:alt', resolvedTitle);
    upsertMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image');
    upsertMeta('meta[name="twitter:title"]', 'name', 'twitter:title', resolvedTitle);
    upsertMeta('meta[name="twitter:description"]', 'name', 'twitter:description', resolvedDescription);
    upsertMeta('meta[name="twitter:image"]', 'name', 'twitter:image', socialImage);
    upsertMeta('meta[name="twitter:image:alt"]', 'name', 'twitter:image:alt', resolvedTitle);
}

export function RouteSeo() {
    const { pathname, search } = useLocation();

    useEffect(() => {
        const state = getRouteSeoState(pathname, search);
        const [title, description] = routeMeta(state.path);
        const notFound = !state.privatePage && !state.knownPage;
        const canonicalUrl = `${ORIGIN}${state.path}`;

        setPageSeo({
            title: state.privatePage ? 'Core Labs' : notFound ? 'Seite nicht gefunden | Core Labs' : title,
            description: notFound ? 'Die angeforderte Seite wurde nicht gefunden.' : description,
            robots: state.indexable ? INDEX_ROBOTS : NOINDEX_ROBOTS,
        });
        upsertMeta('meta[property="og:locale"]', 'property', 'og:locale', 'de_DE');
        upsertMeta('meta[property="og:site_name"]', 'property', 'og:site_name', 'Core Labs');
        upsertMeta('meta[property="og:url"]', 'property', 'og:url', canonicalUrl);
        setCanonical(canonicalUrl);
        syncRouteSchema(state.path, state.knownPage && !state.privatePage);
    }, [pathname, search]);

    return null;
}

export default RouteSeo;
